import { render, staticRenderFns } from "./teaIndexBasicInfo.vue?vue&type=template&id=0ea6444a"
import script from "./teaIndexBasicInfo.vue?vue&type=script&lang=js"
export * from "./teaIndexBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./teaIndexBasicInfo.vue?vue&type=style&index=0&id=0ea6444a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports